import Vue from "vue";
import Router from "vue-router";
import * as Global from '../../global';
import magazine from './modules/magazine';
import home from './modules/home.js'
import Layout from '@/layout';
import contribution from './modules/contribution';
import essay from './modules/essay';
import periodical from './modules/periodical';


Vue.use(Router);

export default new Router({
	mode: "history",
	base: Global.basePath,
	routes: [
		...home,
		...magazine,
		...contribution,
		...essay,
		...periodical,
		{
			path: "/",
			component: Layout,
			children: [{
				path: "/",
				component: () => import("../views/home/index.vue"),
				name: "首页",
			}]
		},
		{
			path: "/login",
			name: "login",
			meta: {
				title: "官方投稿渠道",
				content: {
					keywords: "上海教育科研",
					description: "本网站和'上海教育科研'微信小程序，为《上海教育科研》杂志仅有的两种官方投稿渠道。其他网站及投稿方式均为假冒，请务必识别清楚。其他详情，请关注“上海教育科研”微信公众号。",
				}
			},
			component: () =>
				import("../views/auth/Login.vue")
		},
		{
			path: "/404",
			name: "notFound",
			component: () =>
				import("../views/404.vue")
		},
		{
			path: "*", // 此处需特别注意置于最底部
			redirect: "/404"
		}
	]
});
